<template>
    <div>
        <div class="footer">
            <div class="footer-main">
                <About/>
    
                <div class="taiwan">
                    <span>专业台矩阵</span>
                    <Taiwan/>
                    <div>
            <span>合作伙伴</span>
            <ul class="partner-list">
              <li>
                <a>
                  <img
                    src="http://imgs-b2b.toocle.com/Public/home/images/zyt/logo/szls/jd.jpg"
                  />
                </a>
              </li>
              <li>
                <a>
                  <img
                    src="https://www.100ec.cn/Public/home/images/zyt/logo/szls/pdd.jpg"
                  />
                </a>
              </li>
              <li>
                <a>
                  <img
                    src="https://www.100ec.cn/Public/home/images/zyt/logo/szls/wph.jpg"
                  />
                </a>
              </li>
              <li>
                <a>
                  <img
                    src="https://www.100ec.cn/Public/home/images/zyt/logo/szls/xm.jpg"
                  />
                </a>
              </li>
              <li>
                <a>
                  <img
                    src="https://www.100ec.cn/Public/home/images/zyt/logo/szls/dw.jpg"
                  />
                </a>
              </li>
              <li>
                <a>
                  <img
                    src="https://www.100ec.cn/Public/home/images/zyt/logo/szls/zdm.png"
                  />
                </a>
              </li>
            </ul>
          </div>
                    <!-- <span>合作伙伴</span>
                    <ul class="partner-list">
                        <li>
                            <a>
                                <img src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/jd.jpg">
                            </a>
                        </li>
                        <li>
                            <a>
                                <img src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/pdd.jpg">
                            </a>
                        </li>
                        <li>
                            <a>
                                <img src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/ks.jpg">
                            </a>
                        </li>
                        <li>
                            <a>
                                <img src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/dy.jpg">
                            </a>
                        </li>
                        <li>
                            <a>
                                <img src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/wph.jpg">
                            </a>
                        </li>
                        <li>
                            <a>
                                <img src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/dada.jpg">
                            </a>
                        </li>
                        <li>
                            <a>
                                <img src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/wph.jpg">
                            </a>
                        </li> 
                        <li>
                            <a>
                                <img src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/flw.jpg">
                            </a>
                        </li>
                        <li>
                            <a>
                                <img src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/thyc.jpg">
                            </a>
                        </li>
                        <li>
                            <a>
                                <img src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/mtmm.jpg">
                            </a>
                        </li>
                        <li>
                            <a>
                                <img src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/dw.jpg">
                            </a>
                        </li>
                        <li>
                            <a>
                                <img src="http://imgs-b2b.toocle.com/Public/home/images/wjsviders/logo/mxjt.jpg">
                            </a>
                        </li>
                    </ul> -->
                </div>
    
                <div class="qrcode">
                    <div class="wx-public">
                        <p>微信公众号</p>
                        <img src="//imgs-b2b.toocle.com/Public/home/images/wx-public.jpg">
                        <p>扫码关注</p>
                    </div>

                    <div class="wx-public">
                        <p>微信小程序</p>
                        <img src="//imgs-b2b.toocle.com/Public/home/images/code/wjs_xcx.jpg">
                        <p>扫码体验</p>
                    </div>
    
                    <div class="wx-private">
                        <p>商务合作</p>
                        <img src="//imgs-b2b.toocle.com/Public/home/images/DR-private.png">
                        <p>联系莫老师</p>
                    </div>
                </div>
            </div>

            <Record/>
        </div>

        <el-dialog
		class="cooperation"
		:visible.sync="$store.state.coopeShow"
		width="20%"
		center
		:show-close="false">
            <h1>商务合作/媒体采访：</h1>
			<p>联系人：陈老师</p>
			<p>电话：0571-85337217</p>
			<p>手机：15168211391</p>
			<p>邮箱：O2O@netsun.com</p>
            <span slot="footer" class="dialog-footer">
			    <el-button type="primary" @click="$store.commit('getBusiness', false)">我知道了</el-button>
		    </span>
		</el-dialog>
    </div>
</template>

<script>
import { About } from 'shared'
import { Taiwan } from 'shared'
import { Record } from 'shared'

export default {
    name: 'Footer',
    components: {
        About,
        Taiwan,
        Record
    }
}
</script>